'use client';

/**
 * ErrorState Component
 *
 * Displays error banner with retry option.
 */

import React from 'react';
import { Button } from '@/components/ui/button';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { AlertCircle, RefreshCw } from 'lucide-react';

interface ErrorStateProps {
  title?: string;
  message?: string;
  retryLabel?: string;
  onRetry?: () => void;
  colSpan?: number;
}

export const ErrorState: React.FC<ErrorStateProps> = ({
  title = 'An error occurred',
  message = 'Failed to load data. Please try again.',
  retryLabel = 'Retry',
  onRetry,
  colSpan,
}) => {
  return (
    <tbody>
      <tr>
        <td colSpan={colSpan} className="px-6 py-8">
          <Alert variant="destructive">
            <AlertCircle className="h-4 w-4" />
            <h5 className="mb-1 font-medium leading-none tracking-tight">{title}</h5>
            <AlertDescription className="mt-2">
              {message}
              {onRetry && (
                <Button
                  variant="outline"
                  size="sm"
                  onClick={onRetry}
                  className="ml-4"
                >
                  <RefreshCw className="h-3 w-3 mr-2" />
                  {retryLabel}
                </Button>
              )}
            </AlertDescription>
          </Alert>
        </td>
      </tr>
    </tbody>
  );
};
